import { createSlice } from "@reduxjs/toolkit";

const pageRecordLimitSlice = createSlice({
    name: "pageRecordLimit",
    initialState: {
        recordLimit: 15,
    },
    reducers: {
        setPageRecordLimit(state, action) {
            state.recordLimit= action.payload;
        },
    },
});

export const { setPageRecordLimit } = pageRecordLimitSlice.actions;
export default pageRecordLimitSlice.reducer;
